export default __webpack_public_path__ + "static/media/Nodejs.4d43fc67.PNG";